import {Component, Inject, isDevMode, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {DatePipe} from "@angular/common"
import firebase from "firebase/compat/app";
import Timestamp = firebase.firestore.Timestamp;
import {environment} from "../../../../../environments/environment";
import {UploadModel} from "../../../../models/UploadModel";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {AngularFireStorage} from "@angular/fire/compat/storage";
import {MatSnackBar} from "@angular/material/snack-bar";
import {needConfirmation} from "../../../../confirm-dialog/confirm-dialog.decorator";


@Component({
  selector: 'app-view-education-group',
  templateUrl: './view-education-group.component.html',
  styleUrls: ['./view-education-group.component.scss']
})
export class ViewEducationGroupComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();

  env = isDevMode() ? environment.testMode : environment.productionMode
  mDocuments:UploadModel[]=[]
  mDbType: 'realtime' | 'firestore' = 'firestore';
  mStoragePath?: string = 'education/group-sessions'
  mPath = 'Education';
  documents$: Observable<unknown | undefined>




  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private datePipe:DatePipe,
              private readonly mStorage:AngularFireStorage,
              private readonly mFirestore:AngularFirestore,
              private readonly _snackBar:MatSnackBar,)
  {    console.log(data)
    this.mStoragePath = this.mStoragePath + '/' + data.id
    this.mPath =this.env.documents+'/'+ this.mPath + '/groupSessions/' + data.id
    console.log(`Document will be uploaded to ${this.mStoragePath} on ${this.mDbType} in ${this.mPath} `)

    // Stamp root-level metadata so the photo gallery can query by date & centre
    const sessionDate = data.sessionDate || data.date || null;
    const centres: any[] = data.centres || [];
    const centreCode = centres.map((c: any) => c.centreCode).filter(Boolean).join(', ');
    const centreName = centres.map((c: any) => c.centreName).filter(Boolean).join(', ');
    this.mFirestore.doc(this.mPath).set({
      date:       sessionDate,
      dateAdded:  sessionDate,
      centreCode: centreCode || data.centreCode || '',
      centreName: centreName || data.centreName || '',
      centres:    centres,
    }, { merge: true });

    this.documents$  = this.mFirestore.doc( this.mPath).valueChanges({idField:'id'})
    this.documents$.pipe(takeUntil(this._destroyed$)).subscribe(res=>{
      // @ts-ignore
      this.mDocuments = res.documents as UploadModel
    })

    //

  }


  ngOnInit(): void {

  }

  getDate(date: Date):any {
    let d = (date as unknown as Timestamp).toDate()
    let datePipeString = this.datePipe.transform(d,'dd-MMM-yyyy');
    return datePipeString
  }


  // getTime(date: Date):any {
  //   let d = (date as unknown as Timestamp).toDate()
  //   let datePipeString = this.datePipe.transform(d,"HH:mm:aa");
  //   return datePipeString
  // }
  getTime(date: Date):any {
    let datePipeString: string | null = "NA"

    if (date!=null){
      let d = (date as unknown as Timestamp).toDate()
      datePipeString = this.datePipe.transform(d,"h:mm a")
      // console.log('DATEPIPE STRING',datePipeString )

      return datePipeString
    }
  }

  getchildrenNames(children: any[]) {
    let arr:any = []
   children.forEach(c=>{
     arr.push(c.childName)
   })
    return arr.toString()
  }

  getCentresString(centres: any) {
    let arr: any[] =[]
    centres.forEach((it: { centreName: any; })=>{
      arr.push(it.centreName)
    })
    return arr
  }

  getChildcode(childCode: any) {
    let arr:any = []
    childCode.forEach((c: { childCode: any; }) =>{
      arr.push(c.childCode)
    })
    return arr.toString()
  }
  trackByMethod(index: number, el: any): number {
    return el.id;
  }

  openLink(fileUrl: string) {
    window.open(fileUrl)

  }

  @needConfirmation()
  deleteAdmissionFile(i: number, d: UploadModel, category: string) {
    const iRef = this.mStorage.storage.refFromURL(d.url)
    iRef.delete().then(() => {
      this.mFirestore.doc(this.mPath).update({
        [category]: firebase.firestore.FieldValue.arrayRemove(d)
      }).then(() => {
        this._snackBar.open('File Deleted Successfully')._dismissAfter(2000)
      })
    })
    console.log(iRef)
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}


